/** @file:接口文件 */
import Vue from 'vue'
import axios from './axios';
import system from './system';
import systemp from './systemp';
import uploads from './upload';
// import router from '../router/index';

let store = '/store';
let api = '/api';
let wework = '/wework';
// let baseURL = '';
let baseURL = process.env.NODE_ENV === 'production'?'':'/devapi';

let imgUrl = window.location.protocol + '//' + window.location.host;
Vue.prototype.baseURL = imgUrl;


axios.defaults.baseURL = baseURL;
system.defaults.baseURL = baseURL;
systemp.defaults.baseURL = baseURL;
uploads.defaults.baseURL = baseURL;


/**@type:系统相关 */
const req  = {
	//图片上传
	reqPostImg:(option) => uploads.post(api + '/upload/image', option),

	
	// 注册
	reqRegister:(option) => systemp.post(api + '/passport/register', option),
	//会员发送短信时需要的验证码
	reqyanzheng:(option) => systemp.get(api + `/passport/captcha`),
	// 会员发送短信 暂时可以直接返回成功并且附带短信验证码，用于下一步验证
	reqSendsms:(option) => systemp.post(api + '/passport/sendsms', option),
	// 手机登录
	reqDengl:(option) => systemp.post(api + '/passport/login', option),


	// 登出
	 reqLoginOut:(option) => system.post(api + '/passport/logout', option),
	
	
	
	//招标信息列表
	reqZhaobiaoList:(option) => systemp.get(api + `/news/list?page=${option.page}`),
	// 招标信息详情
	reqZhaobiaoInfo:(option) => systemp.get(api + `/news/detail?id=${option.id}`),

	//招标信息分类列表
	reqLei:(option) => systemp.get(api + `/acategory/list`),

	//中标公示列表
	reqCommentList:(option) => systemp.get(api + `/comment/list?page=${option.page}&status=1`),



	// 需要登录的接口
	//我要投标
	reqtoubiao:(option) => system.post(api + '/comment/submit', option),
		//重新投标
		cctoubiao:(option) => system.post(api + '/comment/renew', option),
	//我的投标记录
	reqcommentList:(option) => system.get(api + `/comment/list?page=${option.page}&user=my`),

	// 我的投标记录详情
	reqWtInfo:(option) => systemp.get(api + `/comment/detail?commentId=${option.commentId}`),

	//获取个人信息
	requser:(option) => system.get(api + `/user/info`),


	// -------------------------------------------------
	
}


export default req;

